<template>
  <div>
    <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>指定パーツ位置設定</h2>
        </div>
        <div v-show="errorMessage.text" class="error_message">
          {{ errorMessage.text }}<br>
        </div>
        <div v-for="(errorMessage, idx) in errorMessages" :key="idx" class="error_message">
          {{ errorMessage }}
        </div>
        <div class="data-area" v-if="updateFrDistList.length > 0">
          <ul>
            <li v-for="(data, index) in updateFrDistList" :key="index">
              <span class="label">{{ data.distName }}
                <span class="tooltip" v-if="data.distCaption">
                  <img :src="imgQMark" width="15px" height="auto"/>
                  <span>
                    {{ data.distCaption }}
                  </span>
                </span>
              </span>
              <div>
                <input type="number" v-model="data.dist" @focus="onFocusInputArea(data.keycd)">
                <div class="dir-text">{{ "(設定範囲：" + updateFrDistList[index].minDist + " ~ " + updateFrDistList[index].maxDist + ")"}}</div>
              </div>
            </li>
          </ul>
        </div>
        <div v-show="!frDistDataList || frDistDataList.length === 0" class="non-data">指定パーツがありません。</div>
        <div class="button-area">
          <button type="button" v-if="frDistDataList.length > 0" class="main_btn" @click="onOk">設定</button>
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import {API_URL, KEY_CODE} from '../../../constants/App'

export default {
  name: 'SetPartsFacerelation',
  components: {},
  props: {
    fileData: Object,
    editCtrlSpaces: Array,
    focusedMenuSpace: Object,
    globalSpaceMap: Map
  },
  data () {
    return {
      modalShown: false,
      editSpace: {},
      /** 取得した面関連情報一覧 */
      frDistDataList: [],
      /** 更新用の面関連情報一覧 */
      updateFrDistList: [],
      errorMessages: [],
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      fieldErrorMessages: {},
      imgQMark: this.getImage('pages/planning/qmark_gray.svg')
    }
  },
  computed: {
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.editSpace = this.focusedMenuSpace != null ? this.focusedMenuSpace : this.editCtrlSpaces[0]
      this.getFrDistDataList()
      this.modalShown = true
    },
    /** 設定ボタン押下時 */
    onOk: function (event) {
      if (!this.modalShown) return
      this.clearMessages()
      this.setFaceDist()
    },
    /** キャンセルボタン押下時 */
    onCancel: function (event) {
      event.preventDefault()
      this.clearMessages()
      this.updateFrDistList = []
      this.$emit('clearFrDistGuideLine')
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** enter/escキー押下時 */
    onKeydown: function (event) {
      if (
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey &&
        event.keyCode === KEY_CODE.ENTER
      ) {
        this.onOk(event)
      } else if (event.keyCode === KEY_CODE.ESC) {
        this.onCancel(event)
      }
    },
    /** 面関連情報取得 */
    getFrDistDataList: function () {
      axios.get(API_URL.PLANNING + '/fr-dist/list/' + this.editSpace.id
      ).then(response => {
        this.frDistDataList = response.data.data
        const allFrDistList = []
        this.frDistDataList.forEach(({ frDistName, frDistCaption, frKeycd, frDist, frDistMin, frDistMax }) => {
          let positiveFlg = true
          // 数値がマイナスだったら表示上はプラスに変換
          let min = frDistMin
          let max = frDistMax
          let reverseFlg = false
          // 数値が0の場合
          if (frDist === 0 && Math.abs(frDistMin) > Math.abs(frDistMax)) {
            reverseFlg = true
          }
          if (frDist < 0 || reverseFlg) {
            positiveFlg = false
            frDist = Math.abs(frDist)
            min = Math.abs(frDistMax)
            max = Math.abs(frDistMin)
          }
          allFrDistList.push({
            distName: frDistName,
            distCaption: frDistCaption,
            dist: frDist,
            keycd: frKeycd,
            maxDist: max,
            minDist: min,
            positiveFlg: positiveFlg
          })
        })
        // KEYが重複しているデータをマージする
        this.updateFrDistList = allFrDistList.filter((fr, index, self) => {
          const cdList = self.map(fr => fr['keycd'])
          if (cdList.indexOf(fr.keycd) === index) {
            return fr
          }
        })
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 値を設定 */
    setFaceDist: function () {
      this.updateFrDistList.forEach(updateFr => {
        this.checkMinMaxValid(updateFr.dist, updateFr.maxDist, updateFr.minDist, updateFr.distName)
      })
      if (this.errorMessages.length > 0) return
      // 取得した面関連情報の更新
      this.updateFrDistList.forEach(updateFr => {
        this.frDistDataList.forEach(fr => {
          if (fr.frKeycd === updateFr.keycd) {
            fr.frDist = updateFr.positiveFlg ? updateFr.dist : -updateFr.dist
          }
        })
      })
      if (this.errorMessages.length === 0) {
        let payload = {
          spaceId: this.editSpace.id,
          frDistDataList: this.frDistDataList
        }
        axios.post(API_URL.PLANNING + '/fr-dist/update', payload
        ).then(response => {
          if (response.data.errorMessage) {
            // エラーメッセージ表示
            this.$emit('handleErrorMessage', response)
          } else {
            this.$emit('clearFrDistGuideLine')
            this.updateFrDistList = []
            this.$emit('closeTreeContextModal')
            this.modalShown = false
            App.showModal({
              messages: ['設定を変更しました。']
            })
            this.$emit('setResponseData', response)
          }
        }).catch(error => {
          // バリデーションエラー
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      }
    },
    /** 入力欄へのフォーカス時 */
    onFocusInputArea: function (keycd) {
      let lineDataList = []
      this.frDistDataList.forEach(fr => {
        if (fr.frKeycd === keycd) {
          let data = {
            id1: fr.frFace1SpaceId,
            id2: fr.frFace2SpaceId,
            faceType1: fr.frFace1Type,
            faceType2: fr.frFace2Type,
            dist: Math.abs(fr.frDist)
          }
          lineDataList.push(data)
        }
      })
      this.$emit('setFrDistGuideLine', lineDataList)
    },
    clearMessages: function () {
      this.errorMessages = []
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {}
    },
    /** 設定値の最大・最小チェック */
    checkMinMaxValid: function (inputDist, maxDist, minDist, frDistName) {
      if (inputDist === '') {
        this.errorMessages.push('[' + frDistName + ']の値を入力してください。')
      } else if (maxDist < inputDist) {
        this.errorMessages.push('[' + frDistName + ']の値が最大値より大きいため設定できません。')
      } else if (minDist > inputDist) {
        this.errorMessages.push('[' + frDistName + ']の値が最小値より小さいため設定できません。')
      }
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>

<style scoped lang="scss">
.data-area {
  padding: 10px 0px;
  overflow: auto;
  max-height: calc(100% - 110px);
  >div {
    display: flex;
    justify-content: center;
    margin-top: 5px;
    margin-bottom: 15px;
    >div{
      min-width: 300px;
    }
  }
  ul {
    padding: 30px 0px;
  }
  li {
    margin-top: 5px;
    margin-bottom: 20px;
    div {
      display: inline-block;
      min-width: 400px;
      .dir-text {
        display: inline-block;
        min-width: 130px;
        text-align: left;
        padding-left: 20px;
      }
    }
    input {
      width: 60px;
    }
  }
}
.non-data {
  margin: 25px;
}
.label {
  display: inline-block;
  text-align: left;
  min-width: 180px;
  padding-bottom: 10px;
}
.error_message {
  margin-top: 5px;
  margin-bottom: 5px ;
}
input.sm {
  width: 60px;
}
.modal .modal-main {
  width: 50%;
  max-width: 80%;
  .title-area {
    padding: 10px 0px 0px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetPartsFacerelationModal.vue